export default "__VITE_ASSET__D2Uow4mx__"